import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import useDate from "../day";
import figureFormatter from "@/services/utils/figureFormatter";
import { loadImageAsBase64 } from "@/services/utils/global";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  SulaimanLipi: {
    normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
    bold: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
    italics: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
    bolditalics: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff'
  }
};

const printMushak66 = () => {
  const { formatDate } = useDate();
  const { commaFormat } = figureFormatter();

  const exportToPdfMushak66 = async (companyInfo, certificate, bills) => {
    const imagePath = await loadImageAsBase64('/app-assets/images/gov_seal.png');
    const doc = {
      pageSize: "A4",
      pageOrientation: "portrait",
      pageMargins: [40, 55, 40, 30],
      defaultStyle: {
        font: "SulaimanLipi",
        fontSize: 9
      },
      content: getContent(companyInfo, certificate, bills, imagePath),
      info: {
        title: 'মূসক-৬.৬'
      },
      styles: styles
    };
    pdfMake.createPdf(doc).open();
  }

  const getContent = (companyInfo, certificate, bills, imagePath) => {
    return [
      getHeaderBlock(imagePath),
      { text: 'উৎসে কর কর্তন সনদপত্র', style: 'h2', margin: [0, 4, 0, 0] },
      { text: '[বিধি ৪০ এর উপ-বিধি (১) এর দফা (চ) দ্রষ্টব্য]', style: 'small', margin: [0, 0, 0, 8] },
      {
        margin: [0, 0, 0, 8],
        columns: [
          {
            width: '*',
            stack: [
              { text: 'উৎসে কর কর্তনকারী সত্তার নাম: ' + getValue(companyInfo.name), style: 'info' },
              { text: 'উৎসে কর কর্তনকারী সত্তার ঠিকানা: ' + getValue(companyInfo.address), style: 'info' },
              { text: 'উৎসে কর কর্তনকারী সত্তার বিআইএন (প্রযোজ্য ক্ষেত্রে): ' + getValue(companyInfo.vat_no), style: 'info' }
            ]
          },
          {
            width: 'auto',
            stack: [
              { text: 'উৎসে কর কর্তন সনদপত্র নং: ' + getValue(certificate.certificate_number), style: 'info', alignment: 'right' },
              { text: 'জারির তারিখ: ' + getRowDate(certificate.date), style: 'info', alignment: 'right', margin: [0, 4, 0, 0] }
            ]
          }
        ]
      },
      { text: getCertifyText(), style: 'justify', margin: [0, 0, 0, 6] },
      {
        table: {
          headerRows: 3,
          widths: getWidths(),
          body: getTableBody(bills)
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineColor: () => '#000',
          vLineColor: () => '#000',
          paddingLeft: () => 2,
          paddingRight: () => 2,
          paddingTop: () => 2,
          paddingBottom: () => 2
        }
      },
      getSignatureBlock()
    ];
  }

  const getHeaderBlock = (imagePath) => {
    const seal = imagePath ? { image: imagePath, width: 45, height: 45 } : { width: 45, text: '' };
    return {
      margin: [0, 0, 0, 2],
      columns: [
        seal,
        {
          width: '*',
          stack: [
            { text: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার', style: 'h1' },
            { text: 'জাতীয় রাজস্ব বোর্ড', style: 'h1', margin: [0, 3, 0, 0] }
          ]
        },
        {
          width: 55,
          margin: [0, 12, 0, 0],
          table: { widths: ['*'], body: [[{ text: 'মূসক-৬.৬', alignment: 'center', fontSize: 9 }]] },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => '#000',
            vLineColor: () => '#000'
          }
        }
      ]
    };
  }

  const getCertifyText = () => {
    return 'এই মর্মে প্রত্যয়ন করা যাইতেছে যে, আইনের ধারা ৪৯ অনুযায়ী উৎসে কর কর্তনযোগ্য সরবরাহ হইতে প্রযোজ্য মূল্য সংযোজন কর বাবদ উৎসে কর কর্তন করা হইল। কর্তনকৃত মূল্য সংযোজন করের অর্থ বুক ট্রান্সফার/ট্রেজারি চালান/দাখিলপত্রে বৃদ্ধিকারী সমন্বয়ের মাধ্যমে সরকারি কোষাগারে জমা প্রদান করা হইয়াছে। কপি এতদসংগে সংযুক্ত করা হইল (প্রযোজ্য ক্ষেত্রে)';
  }

  const getWidths = () => {
    return [30, '*', 70, 60, 60, 65, 60, 70];
  }

  const getTableBody = (bills) => {
    return [
      getGroupHeaderRow(),
      getLeafHeaderRow(),
      getNumberRow(),
      ...getDataRows(bills),
      getTotalRow(bills)
    ];
  }

  const getGroupHeaderRow = () => {
    return [
      { text: 'ক্রমিক নং', style: 'th', rowSpan: 2 },
      { text: 'সরবরাহকারীর', style: 'th', colSpan: 2 }, {},
      { text: 'সংশ্লিষ্ট কর চালানপত্র', style: 'th', colSpan: 2 }, {},
      { text: 'মোট মূল্য (টাকা)', style: 'th', rowSpan: 2 },
      { text: 'মূসকের পরিমাণ (টাকা)', style: 'th', rowSpan: 2 },
      { text: 'উৎসে কর্তনকৃত মূসকের পরিমাণ (টাকা)', style: 'th', rowSpan: 2 }
    ];
  }

  const getLeafHeaderRow = () => {
    return [
      {},
      { text: 'নাম', style: 'th' },
      { text: 'বিআইএন', style: 'th' },
      { text: 'নম্বর', style: 'th' },
      { text: 'ইস্যুর তারিখ', style: 'th' },
      {}, {}, {}
    ];
  }

  const getNumberRow = () => {
    const nums = ['(১)', '(২)', '(৩)', '(৪)', '(৫)', '(৬)', '(৭)', '(৮)'];
    return nums.map(function (n) {
      return { text: n, style: 'th' };
    });
  }

  const getDataRows = (bills) => {
    if (!bills || !bills.length) return [getBlankRow()];
    return bills.map((item, index) => mapRow(item, index));
  }

  const mapRow = (item, index) => {
    return [
      { text: convertToBanglaNumber(index + 1), style: 'td' },
      { text: getValue(item.party_name), style: 'tdLeft' },
      { text: getValue(item.party_bin_no), style: 'td' },
      { text: getValue(item.bill_referance_no), style: 'td' },
      { text: getRowDate(item.bill_referance_date), style: 'td' },
      { text: money(item.bill_amount), style: 'tdRight' },
      { text: money(item.vat_amount), style: 'tdRight' },
      { text: money(item.vds_amount), style: 'tdRight' }
    ];
  }

  const getTotalRow = (bills) => {
    const totalBill = sumBy(bills, 'bill_amount');
    const totalVat = sumBy(bills, 'vat_amount');
    const totalVds = sumBy(bills, 'vds_amount');
    return [
      { text: 'মোট', style: 'thRight', colSpan: 5 }, {}, {}, {}, {},
      { text: money(totalBill), style: 'thRight' },
      { text: money(totalVat), style: 'thRight' },
      { text: money(totalVds), style: 'thRight' }
    ];
  }

  const getBlankRow = () => {
    return Array.from({ length: 8 }, () => ({ text: ' ', style: 'td' }));
  }

  const getSignatureBlock = () => {
    return {
      stack: [
        { text: 'ক্ষমতাপ্রাপ্ত কর্মকর্তার-', margin: [0, 30, 0, 0] },
        { text: 'স্বাক্ষর:', margin: [0, 4, 0, 0] },
        { text: 'নাম:', margin: [0, 4, 0, 0] }
      ]
    };
  }

  const getRowDate = (date) => {
    if (!date) return '';
    return formatDate(new Date(date)).split(' ')[0];
  }

  const getValue = (value) => {
    if (!value) return '';
    return value;
  }

  const getNumber = (value) => {
    if (!value) return 0;
    return parseFloat(value);
  }

  const sumBy = (list, key) => {
    if (!list || !list.length) return 0;
    return list.reduce((acc, item) => acc + getNumber(item[key]), 0);
  }

  const money = (value) => {
    if (!value) return 0;
    return commaFormat(value);
  }

  const convertToBanglaNumber = (number) => {
    const banglaDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
    return number.toString().split('').map(d => banglaDigits[d] || d).join('');
  }

  const styles = {
    h1: { fontSize: 12, alignment: 'center' },
    h2: { fontSize: 11, alignment: 'center' },
    small: { fontSize: 9, alignment: 'center' },
    info: { fontSize: 9, alignment: 'left' },
    justify: { fontSize: 9, alignment: 'justify' },
    th: { fontSize: 8, alignment: 'center', lineHeight: 1.1 },
    thRight: { fontSize: 8, alignment: 'right' },
    td: { fontSize: 8, alignment: 'center' },
    tdRight: { fontSize: 8, alignment: 'right' },
    tdLeft: { fontSize: 8, alignment: 'left' }
  };

  return {
    exportToPdfMushak66
  }
}

export default printMushak66;
